var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.products)?_c('one-related-products',{staticClass:"one-related-products-wrapper container mx-auto px-0",attrs:{"data":_vm.products,"title":_vm.title,"is-list":_vm.isList},on:{"add-to-cart":_vm.onAddToCart,"add-to-wishlist":_vm.onAddToWishlist,"product-click":_vm.onProductClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }